import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio219: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"aspect-ratio-21-9, wide, landscape"} maskId="square-filled-radius-0-stroke-1-IconAspectRatio219"><path d="M0 6V18H24V6H0Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAspectRatio219;
